import { render, staticRenderFns } from "./MultiLanguagesDialog.vue?vue&type=template&id=7c193a4c&scoped=true&lang=pug&"
import script from "./MultiLanguagesDialog.vue?vue&type=script&lang=ts&"
export * from "./MultiLanguagesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MultiLanguagesDialog.vue?vue&type=style&index=0&id=7c193a4c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c193a4c",
  null
  
)

export default component.exports